import { Component,EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_List_Interface, Empty_Calibration_List_Interface } from 'src/app/Interface/Calibration_List_Interface';
import { Empty_LetterRequestCustomer_Funds_Interface, LetterRequestCustomer_Funds_Interface } from 'src/app/Interface/LetterRequestCustomer_Funds_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FundsService } from 'src/app/Service/Funds/Funds.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-FundsLetterList',
  templateUrl: './FundsLetterList.component.html',
  styleUrls: ['./FundsLetterList.component.scss']
})
export class FundsLetterListComponent implements OnInit {


  @Input() inner_Calibration: Calibration_List_Interface = Empty_Calibration_List_Interface()
  @Output() OnBack_Calibration_Action = new EventEmitter<number>();
  InProccessing: boolean = false
  modalRef_Delete: any;
  page:any
  BaseUrl = environment.BaseUrl

  Total_Funds:number=0
  DataList_Funds: Array<LetterRequestCustomer_Funds_Interface> = []
  Data_Seleted_Delete: LetterRequestCustomer_Funds_Interface = Empty_LetterRequestCustomer_Funds_Interface()

  constructor(
    private Funds_Service: FundsService,
    private modalService: BsModalService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.ReadData_Funds()
  }

  ReadData_Funds() {
    this.InProccessing = true
    this.Funds_Service.GetSchedule(Number(this.inner_Calibration.letterRequestSchduleCustomer_id)
    ).subscribe(
      data => {
        this.DataList_Funds = data

        this.Total_Funds=0
        for (let item of data)
        {
          if (item.status != -1)
          {
            this.Total_Funds=this.Total_Funds+item.price
          }
        }

        this.InProccessing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Delete(item: LetterRequestCustomer_Funds_Interface) {
    this.InProccessing  = true
    this.modalRef_Delete.hide()
    this.Funds_Service.DeleteSchedule(item.id).subscribe(
      data => {
        this.InProccessing  = false
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_Funds()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  OnSet_Back_CalibrationList(){
    this.OnBack_Calibration_Action.emit(-1);

  }



  //#region Funds Form

  Selected_Funds_Record: LetterRequestCustomer_Funds_Interface
  Selected_Funds_Record_Switcher: string = 'List'
  Set_List_Funds_View() {
    this.Selected_Funds_Record_Switcher = 'List'
    this.ReadData_Funds()
  }

  Set_Form_Funds_View(item:LetterRequestCustomer_Funds_Interface,Switcher:string) {
    this.Selected_Funds_Record = item
    this.Selected_Funds_Record_Switcher = Switcher
  }

  Set_Form_Funds_View_Add() {
    this.Selected_Funds_Record = Empty_LetterRequestCustomer_Funds_Interface()
    this.Selected_Funds_Record_Switcher = 'Form'
  }

  //#endregion

}
